import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <h2>Follow me</h2>

      <div>
        <a href="https://www.instagram.com/antsavvidesfitness__?igsh=MWo4aW9sdW5tYjgxYQ==">
          {" "}
          <div className="icon">
            <i class="fa-brands fa-instagram"></i>
          </div>
        </a>{" "}
        <a
          href="https://www.instagram.com/antsavvidesfitness__?igsh=MWo4aW9sdW5tYjgxYQ=="
          className="anthonyinsta"
          target="_blank"
          rel="noreferrer"
        >
          @antsavvidesfitness__
        </a>
      </div>
      <a
        href="https://www.instagram.com/antsavvidesfitness__?igsh=MWo4aW9sdW5tYjgxYQ=="
        target="_blank"
        rel="noreferrer"
      >
        <p id="contact">Contact me for a free consultation</p>
      </a>
    </div>
  );
}
